"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioButtonOn = _interopRequireDefault(require("../../../icons/inputs/RadioButtonOn"));

var _RadioButtonOff = _interopRequireDefault(require("../../../icons/inputs/RadioButtonOff"));

var _withStyles = _interopRequireDefault(require("../../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioButton = function RadioButton(_ref) {
  var classes = _ref.classes,
      id = _ref.id,
      name = _ref.name,
      selected = _ref.selected,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["classes", "id", "name", "selected", "label", "value", "onChange", "disabled"]);

  var radioIcon = selected ? _react["default"].createElement(_RadioButtonOn["default"], {
    classes: {
      root: classes.radio,
      border: classes.radioBorder
    }
  }) : _react["default"].createElement(_RadioButtonOff["default"], {
    className: classes.radio
  });
  return _react["default"].createElement("label", _extends({
    htmlFor: id,
    className: (0, _classnames["default"])(classes.root, disabled ? classes.disabled : null)
  }, props), _react["default"].createElement("input", {
    className: classes.inputEl,
    id: id,
    name: name,
    type: "radio",
    checked: selected,
    value: value,
    onChange: onChange,
    disabled: disabled
  }), radioIcon, label);
};

RadioButton.propTypes = {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  selected: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].string
};
RadioButton.defaultProps = {
  id: null,
  selected: false,
  label: '',
  onChange: function onChange() {},
  disabled: false,
  value: ''
};

var _default = (0, _withStyles["default"])(_styles["default"])(RadioButton);

exports["default"] = _default;